// src/redux/features/Product/reviewThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { authAxiosInstance } from "../../../utils/axiosinstance";

export const getUserReview = createAsyncThunk(
  "reviews/getUserReview",
  async (productId, { getState, rejectWithValue }) => {
    try {
      // ✅ اصلاح: استفاده از auth به جای userLogin
      const { auth } = getState();
      const userInfo = auth?.userInfo;
      if (!userInfo) {
        return rejectWithValue({ detail: 'لطفاً وارد شوید' });
      }
      const authBackend = authAxiosInstance(userInfo);
      const response = await authBackend.get(`/api/v1/products/${productId}/reviews/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: 'خطا در دریافت امتیاز' });
    }
  }
);

export const createReview = createAsyncThunk(
  "reviews/createReview",
  async ({ productId, rating, comment = '' }, { getState, rejectWithValue }) => {
    try {
      // ✅ اصلاح: استفاده از auth به جای userLogin
      const { auth } = getState();
      const userInfo = auth?.userInfo;
      if (!userInfo) {
        return rejectWithValue({ detail: 'لطفاً وارد شوید' });
      }
      const authBackend = authAxiosInstance(userInfo);
      const response = await authBackend.post(`/api/v1/products/${productId}/reviews/`, {
        rating,
        comment,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: 'خطا در ثبت امتیاز' });
    }
  }
);

export const deleteReview = createAsyncThunk(
  "reviews/deleteReview",
  async (productId, { getState, rejectWithValue }) => {
    try {
      // ✅ اصلاح: استفاده از auth به جای userLogin
      const { auth } = getState();
      const userInfo = auth?.userInfo;
      if (!userInfo) {
        return rejectWithValue({ detail: 'لطفاً وارد شوید' });
      }
      const authBackend = authAxiosInstance(userInfo);
      await authBackend.delete(`/api/v1/products/${productId}/reviews/`);
      return productId;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: 'خطا در حذف امتیاز' });
    }
  }
);